<section class="redes">
  <div>
    <h5>FRAT</h5>
    <a href="https://wa.link/qch118"> <img class="imagenesRedes "
        src="./../../assets/images/img/LOGO WHATSAPP BLANCO.png" alt="wa"></a>
  </div>
  <div>
    <h5>All Tickets</h5>
    <a
      href="https://api.whatsapp.com/send?phone=573209644716&text=Hola%20All%20Tickets,%20me%20comunico%20con%20ustedes%C2%A0porque:">
      <img class="imagenesRedes " src="./../../assets/images/img/LOGO WHATSAPP BLANCO.png" alt="wa"></a>
  </div>

</section>